<template>
  <div v-bind:id="`accept-` + job.job_id" class="mb-3 pb-1">
    <div class="job-link component position-relative">
      <div
        class="card"
        :class="[accept || highlight || (job.applicants_count && user.type == 2) ? 'bg-highlight' : '']"
      >
        <div class="card-top-row">
          <div v-if="parseInt(job.percentage) && sub_branch !== '2'" class="match_percentage">
            {{ parseInt(job.percentage) }}% match
          </div>
          <div v-if="parseInt(job.is_interested)" class="bell">
            <svg-icon icon="notification_bell" />
          </div>
        </div>
        <div class="card-body">
          <div class="card-body-inner" :class="[arrow ? 'w-arrow' : 'no-arrow']">
            <div class="jobCardSpecs-image">
              <img v-if="job.company_avatar" :src="job.company_avatar" class="img-item" />
              <svg-icon v-else icon="education" class="img-item" />
            </div>
            <div class="jobCardSpecs">
              <router-link :to="{ name: 'job', params: params}">
                <ul>
                  <template v-if="sub_branch == '2' || (sub_branch == '1' && job.duration_type == 1)">
                    <li>
                      <svg-icon icon="calendar"></svg-icon>
                      <b>Start: {{ getFirstWorkingDate() }}</b>
                      <span class="duration_type recent_yellow" v-if="sub_branch == '1' && job.duration_type == 1">Langdurig</span>
                    </li>
                    <li>
                      <svg-icon icon="calendar"></svg-icon>
                      <b>Eind: {{ getLastWorkingDate() }}</b>
                    </li>
                  </template>
                  <li v-else-if="subtitle"><svg-icon icon="calendar"></svg-icon><b>Start: {{ subtitle[0] }}</b><span class="duration_type recent"> {{ subtitle[1] }}</span></li>
<!--                  <li><svg-icon icon="blackboard"></svg-icon>Groep {{ localFormattedAudience }}</li>-->
                  <li v-if="job.city">
                    <svg-icon icon="marker"></svg-icon>
                    <span v-if="job.name_location">{{ job.name_location }} ({{ job.city }})</span>
                    <span v-else>{{ job.city }}</span>
                  </li>
                  <li><svg-icon icon="education"></svg-icon>{{ job.company_name }}</li>
                </ul>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      sub_branch: localStorage.getItem("subBranch"),
      subtitle: [],
      params: {},
      localFormattedAudience: null
    };
  },
  props: {
    job: Object,
    index_key: null,
    accept: Boolean,
    arrow: Boolean,
    highlight: Boolean,
  },
  watch: {
    $route: "fetchData",
    job: {
      immediate: true,
      deep: true,
      handler() {
        this.params["id"] = this.job.job_id;
        this.params["action"] = "apply";
        
        // Calculate subtitle based on job data
        if (this.job.working_dates) {
          try {
            let working_dates = JSON.parse(JSON.parse(this.job.working_dates));
            let formatedFirstDate = new Date(Object.keys(working_dates)[0]).toLocaleDateString();
            let _subtitle_split = [];
            if (Object.keys(working_dates).length > 1) {
              _subtitle_split = [
                formatedFirstDate,
                Object.keys(working_dates).length + " dagen"
              ];
            } else {
              _subtitle_split = [formatedFirstDate, ": één dag"];
            }
            this.subtitle = _subtitle_split;
          } catch (error) {
            console.error('Error parsing working_dates:', error);
          }
        }

        try {
          if (this.job.audience) {
            this.localFormattedAudience = JSON.parse(this.job.audience).join(', ');
          }
        } catch (error) {
          console.error('Error parsing job.audience:', error);
          this.localFormattedAudience = this.job.audience;
        }
      }
    }
  },
  methods: {
    async onApply(id, job_percentage) {
      window.scrollTo(0, 0);
      this.$emit("notification", "comment");
      this.$emit("job-id-change", id, job_percentage, this.index_key);
    },
    getFirstWorkingDate() {
      let working_dates = this.job.hired_dates
          ? JSON.parse(this.job.hired_dates)
          : JSON.parse(JSON.parse(this.job.working_dates));
      return new Date(Object.keys(working_dates)[0]).toLocaleDateString();
    },
    getLastWorkingDate() {
      let working_dates = this.job.hired_dates
          ? JSON.parse(this.job.hired_dates)
          : JSON.parse(JSON.parse(this.job.working_dates));
      return new Date(Object.keys(working_dates)[Object.keys(working_dates).length - 1]).toLocaleDateString();
    },
  }
};
</script>

<style scoped>


.card .card-top-row {
  display: grid;
  grid-auto-flow: column;
  position: absolute;
  top: -15px;
  width: 100%
}

.card .card-top-row .match_percentage {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  font-weight: normal;
  height: 25px;
  width: 85px;
  border-radius: 10px;
  font-size: 12px;
  color: #64513d;
  background-color: #FFCD00;
  margin-left: 15px;
}

.card .card-top-row .bell {
  margin-right: 15px;
  justify-self: flex-end;
  background-color: #FFF;
}

.job-link .card {
  border: 2px solid #f6f6f6;
  border-radius: 10px;
}

.job-link .card-body {
  padding: 25px 15px;
}

.card-body-inner {
  display: flex;
  align-items: center;
}

.jobCardSpecs .duration_type {
  border-radius: 10px;
  font-size: 12px;
  padding: 3px 15px;
  margin-left: 5px;
}

.jobCardSpecs .duration_type.recent {
  height: 25px;
  background-color: #F6F6F6;
}

.jobCardSpecs .duration_type.recent_yellow {
  height: 25px;
  background-color: #FFF9E2;
}

.jobCardSpecs-image {
  position: relative;
  height: 85px;
  min-width: 85px;
  border-radius: 100px;
  border: 2px solid #f6f6f6;
  background-size: cover;
  background-position: center center;
  margin-right: 18px;
  overflow: hidden;
}

.jobCardSpecs-image .img-item {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.jobCardSpecs-image .img-item /deep/svg {
  width: 100%;
  height: 100%;
  padding: 15px;
}

.jobCardSpecs a {
  color: #64513d;
}

.jobCardSpecs ul {
  font-size: 12px;
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.jobCardSpecs ul li {
  display: flex;
  align-items: center;
}

.jobCardSpecs ul li:not(:last-child) {
  margin-bottom: 10px;
}

/deep/ .jobCardSpecs ul li .svg-container {
  display: flex;
  align-items: center;
}

/deep/ .jobCardSpecs ul li svg {
  color: #ffcd00;
  width: 15px;
  max-height: 15px;
  margin-right: 6px;
}

.text.location {
  max-width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
